<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;background-color: #fff;">
			<LayoutHeader />
		</div>
		<div style="width: 1200px;margin: 20px auto 116px;">
			<a-card>
				<div style="text-align:center;margin-bottom:20px;">
					<h2 style="border-bottom: 1px solid #DEDEDE;padding-bottom: 20px;">刻章备案登记</h2>
					<span v-if="form.schedule=='2'" style="color:#ff4d4f;font-size:20px">审核未通过：{{ form.reason }}</span>
				</div>
				<a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules">
					<!--可编辑区域 start-->
					<div class="hidden">
						<a-form-item label="id" name="id">
							<a-input style="width:100%" v-model:value="form.id" />
						</a-form-item>

						<a-form-item label="companyCode" name="companyCode">
							<a-input style="width:100%" v-model:value="form.companyCode" />
						</a-form-item>
					</div>
					<a-row :gutter="[24, 8]">
						<a-col :span="24">
							<p style="background:#fff7f5;padding:10px 20px;color:#FF6833;border:1px solid #FF6833;margin-bottom: 20px;">
								温馨提示：阳泉高新区为新开办企业及个转企免费刻制3枚印章（公章、法人章、财务专用章、合同专用章、发票专用章，任选3枚），为新开办个体工商户免费刻制1枚公章，免费印章均为光敏印章。详情请咨询0353-2292800/0353-2292128。
							</p>
						</a-col>
                        <a-col :span="24">
                            <div class="filePost">
                                <h3>企业名称</h3>
                            </div>
                        </a-col>
						<a-col :span="24">
							<a-form-item name="companyName">
								<a-input @blur="changeCompany" v-model:value="form.companyName" placeholder="请输入企业名称" />
								<span v-if="companyChange>0&&form.companyName" style="color:#ff4d4f">当前公司已申请过免费刻章</span>
								<!-- <span v-if="companyChange==0&&form.companyName" style="color:#047400">企业为新办企业</span> -->
							</a-form-item>
						</a-col>
						<a-col :span="24">
							<div class="filePost">
								<h3>附件提供</h3>
							</div>
						</a-col>
						<a-col :span="8">
							<a-form-item label="营业执照正本原件照片(图片格式)" name="businessLicense">
								<ImgDragUpload v-model:value="form.businessLicense" />
								<!-- <file-upload v-model:value="form.businessLicense" :size="800" :isPdfImg="true"  /> -->
							</a-form-item>
						</a-col>
						<a-col :span="10">
							<a-form-item label="营业执照副本原件照片(图片格式)" name="businessLicenseSide">
								<ImgDragUpload v-model:value="form.businessLicenseSide" />
								<!-- <file-upload v-model:value="form.businessLicenseSide" :size="800" :isPdfImg="true"  /> -->
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="法人身份证正面照片(图片格式)" name="legalPersonCard">
								<ImgDragUpload v-model:value="form.legalPersonCard" />
								<!-- <file-upload v-model:value="form.legalPersonCard" :size="800" :isPdfImg="true"  /> -->
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="法人身份证反面照片(图片格式)" name="legalPersonCardSide">
								<ImgDragUpload v-model:value="form.legalPersonCardSide" />
								<!-- <file-upload v-model:value="form.legalPersonCardSide" :size="800" :isPdfImg="true"  /> -->
							</a-form-item>
						</a-col>
                        <a-col :span="8">
                            <a-form-item label="法人半身照（图片格式）" name="legalPersonPhoto">
                                <ImgDragUpload v-model:value="form.legalPersonPhoto" />
                                <!-- <file-upload v-model:value="form.legalPersonPhoto" :size="800" :isPdfImg="true"  /> -->
                            </a-form-item>
                        </a-col>
						<a-col :span="8">
							<a-form-item name="agentCardFile">
								<template #label>
									<div>
										<div style="display: block;width:100%">
											经办人身份证正面照片(图片格式)
										</div>
										<div style="color: red; white-space: pre-line;">
											（法定代表人委托他人办理刻章备案登记，需上传该项资料）
										</div>
									</div>
								</template>
								<ImgDragUpload v-model:value="form.agentCardFile" />
								<!-- <file-upload v-model:value="form.agentCardFile" :size="800" :isPdfImg="true"  /> -->
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item name="agentCardFileSide">

								<template #label>
									<div>
										<div style="display: block;width:100%">
											经办人身份证反面照片（图片格式）
										</div>
										<div style="color: red; white-space: pre-line;">
											（法定代表人委托他人办理刻章备案登记，需上传该项资料）
										</div>
									</div>
								</template>
								<ImgDragUpload v-model:value="form.agentCardFileSide" />
								<!-- <file-upload v-model:value="form.agentCardFileSide" :size="800" :isPdfImg="true"  /> -->
							</a-form-item>
						</a-col>
                        <a-col :span="8">
                            <a-form-item name="agentPhoto">


                                <template #label>
                                    <div>
                                        <div style="display: block;width:100%">
                                            经办人半身照（图片格式）
                                        </div>
                                        <div style="color: red; white-space: pre-line;">
                                            （法定代表人委托他人办理刻章备案登记，需上传该项资料）
                                        </div>
                                    </div>
                                </template>
                                <ImgDragUpload v-model:value="form.agentPhoto" />
                                <!-- <file-upload v-model:value="form.agentPhoto" :size="800" :isPdfImg="true"  /> -->
                            </a-form-item>
                        </a-col>
						<a-col :span="18">
							<a-form-item style="position: relative;"  label="刻章备案登记表：经办人自备委托书由法人签字并按手印
                    或直接加盖法人章(PDF,图片格式)" name="registrationForm">

								<file-upload style="float:left;
												width: 200px;
												height: 40px;margin-right:20px;" v-model:value="form.registrationForm" :size="800" :isPdfImg="true" />
<!--								<a-button style="background: #a8a8a8;border:1px solid #a8a8a8" type="primary"-->
<!--									@click="exportExcelTemplate1">-->
<!--									刻章备案登记表模板下载-->
<!--								</a-button>-->
                                <div @click="exportExcelTemplate1" style="color:#0059B5;position: absolute;top:-32px;right:100px;cursor: pointer;">刻章备案登记表模板下载</div>
							</a-form-item>
						</a-col>
						<a-col :span="24">
							<a-form-item style="position:relative" label="取章地址" name="mailingAddress">
								<a-radio-group v-model:value="form.mailingAddress"
									name="radioGroup">
									<a-radio style="display:block;margin-bottom:10px" value="0">阳泉高新区政务大厅 北海路8号 0353-2292800</a-radio>
									<a-radio style="display:block;margin-bottom:10px" value="1" disabled>居馨社区 桃源街居馨巷 0353-2932520</a-radio>
									<a-radio style="display:block;margin-bottom:10px" value="2" disabled>建设银行泉中支行 泉中路八中对面
										0353-6668586</a-radio>
									<a-radio style="display:block;margin-bottom:10px" value="3" disabled>建设银行保晋路支行 保晋路天峰国际底商
										0353-6668524</a-radio>
									<a-radio style="display:block;margin-bottom:10px" value="4" disabled>数智红谷 大连街北山西路
										0353-5676188</a-radio>
									<a-radio style="display:block;margin-bottom:10px" value="5" disabled>御康社区 书香门第11号底商
										0353-2902077</a-radio>
									<a-radio style="display:block;margin-bottom:10px" value="6" disabled>建设银行天津街支行 天津街38号康达一期对面
										0353-6668625</a-radio>
									<a-radio style="display:block;margin-bottom:10px" value="7" disabled>五渡园区 虹桥路65号规自局一楼
										0353-2292606</a-radio>
									<a-radio style="display:block;margin-bottom:10px" value="8" disabled>东城水岸社区 桃北东街 0353-2027606</a-radio>
									<a-radio style="display:block;margin-bottom:10px" value="9" disabled>杨家庄乡 杨家庄乡政府院内
										0353-5021028</a-radio>
								</a-radio-group>
							</a-form-item>
						</a-col>
						<!--可编辑区域 end-->
						<a-col :span="24" style="text-align: center;">
							<a-button style="margin-right:20px" type="primary" @click="isSubmit">
								提交
							</a-button>
							<a-button @click="back">
								返回
							</a-button>
						</a-col>
					</a-row>
				</a-form>
			</a-card>
		</div>
		<LayoutFooter />
	</div>
</template>
<script>
import { ls } from "@/utils/util"
import axios from "axios";
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import LayoutHeader from '@/layout/layoutPage/header/LayoutHeaderNew2';
import { common } from "@/api/finance"
import { notification } from "ant-design-vue";
import { file_service } from "@/api/adminService";
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { enterpriseEngraveApply } from "@/api/EnterpriseSealService";
import { SealService } from "@/config/variableConfig";

export default {
	name: "AddOrEditModal",
	components: {
		LayoutFooter,
        LayoutHeader
	},

	mixins: [formMixin],
	data() {
		return {
			companyChange:null,
			SealService,
			waitTime: 61,
			all_logo: '',
			user: {},
			formState: {
				user: undefined,
			},
			webSiteInfo: {},
			linkData: [],
			pwOk: null,
			companyShow: null,
			optionsRoleTreeList: null,
			optionsMechanIsmTreeList: null,
			optionsBaseTreeTreeList: null,
			optionsTreeList: null,
			codeLength: 4,
			inputvalue: '',
			show: false,
			showerror: false,
			platformName,
			confirmLoading: false,
			codeBtnWord: '获取短信验证码',
			captchaPath: '',
			redirectPath: '/',

			form: {
				id: null,
				companyName:null,
				companyCode: null,
				reason: null, //原因
				enterpriseSealInfos: [],
				collectionMethod: 0,
				isMarket: 0, //是否为新办市场主体
				isEnterprise: 0, //是否个转企
				mailingAddress: '0',
				agent: null,
				agentPhone: null,
				isSubmit: 0,
				schedule: '0',
				authPeriod: null,
				agentIdCard: null,
				businessLicense: null,
				businessLicenseSide: null,
				legalPersonCard: null,
				legalPersonCardSide: null,
				agentCardFile: null,
				agentCardFileSide: null,
				legalPersonPhoto: null,
				agentPhoto: null,
				// circulationOrder: null,
				registrationForm: null,
				// powerOfAttorney: null,
			},
			editableData: {},
			rules: {
				id: [],
				companyName:[dataCheck.required({})],
				companyCode: [],
				isMarket: [], //是否为新办市场主体
				isEnterprise: [], //是否个转企
				reason: [],
				collectionMethod: [dataCheck.required({ type: 'number' })],
				enterpriseSealInfos: [dataCheck.required({ type: 'array' })],
				mailingAddress: [dataCheck.required({})],
				agent: [dataCheck.required({})],
				agentPhone: [dataCheck.required({}), dataCheck.phone],
				authPeriod: [dataCheck.required({})],
				isSubmit: [],
				schedule: [],
				agentIdCard: [dataCheck.required({}), dataCheck.id_num],
				businessLicense: [dataCheck.required({})],
				businessLicenseSide: [dataCheck.required({})],
				legalPersonCard: [dataCheck.required({})],
				legalPersonCardSide: [dataCheck.required({})],
				agentCardFile: [],
				agentCardFileSide: [],
				legalPersonPhoto: [dataCheck.required({})],
				agentPhoto: [],
				// circulationOrder: [dataCheck.required({})],
				registrationForm: [dataCheck.required({})],
				// powerOfAttorney: [dataCheck.required({})],

			},

			options: [],
			submitType: 'json'

		}
	},
	watch:{
		'form.companyName'(val){
			if(!val){
				this.companyChange = null
			}
		},
	},
	computed: {
		submitUrl() {
			return enterpriseEngraveApply.saveOrUpdate
		}
	},
	mounted() {
		this.all_logo = this.$ls.get('all_logo');
		if (this.$route.query.gourl == 'list') {
			this.form.companyCode = this.$route.query.id
			this.form.id = this.$route.query.id
			this.getFormData()
		} else if (this.$route.query.gourl == 'add') {
			this.form.companyCode = this.$route.query.id
		}
	},
	methods: {
		/**
		 * @description: 封装JWT heaers 函数
		 * @param {*} method
		 * @param {*} url
		 * @param {*} params
		 * @param {*} fun
		 * @return {*}
		 */
		getAxios(method, url, params, fun) {
			console.log(params.params)
			axios({
				method: method,
				headers: {
					AuthenticationPhone: ls.get('jwtphone'),
					AuthenticationJwt: ls.get('jwtMain')
				},
				url: url,
				data: method==='post'?params.params:{},
                params: method==='get'?params.params:{}
			}).then(res => {
				if(res.data.code==544){
					notification.warning({
						message: '登录过期',
						style: {
							width: '400px',
							fontWeight: '600',
							marginLeft: `${-200}%`,
							marginTop: `${20}%`,
						}
					});
					setTimeout(() => {
							this.$router.push('/')
					}, 50);
				}else{
					if (res) {
						fun(res)
					}
				}
			})
		},

  /**
   * @description: 认证企业是否重复
   * @return {*}
   */
		changeCompany(){
			this.getAxios('get',enterpriseEngraveApply.queryCompanyName,{
				params:{companyName: this.form.companyName}
			}, (res) => {
				if(res.data.data){
					this.companyChange=true
				}else{
					this.companyChange=false
				}
			})
		},
		scrollToTop() {
			window.scrollTo(0, 0);
		},

		postSeed() {
			this.$refs.ruleForm
				.validate('phoneNumber')
				.then((values) => {
					this.confirmLoading = true;
					this.postAction({
						url: common.sendCode,
						params: {
							mobilePhone: values.phoneNumber,
						}
					}
					).then((res) => {
						if (res.code == '0') {
							notification.success({
								message: '验证码发送成功，请查看邮箱',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '1') {
							notification.success({
								message: '邮箱不存在，请联系平台管理员补充邮箱',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '2') {
							notification.success({
								message: '今日验证码已达上限，24小时后重新申请',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '3') {
							notification.success({
								message: '邮箱功能未开通，联系管理员设置',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '4') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}
						this.confirmLoading = false;
						// this.$router.push(this.redirectPath);
					}).catch((err) => {
						console.log(err, 'err')
						this.confirmLoading = false;
					})
				})
				.catch(() => {
				})
		},

		goMore(url, str, gourl) {
			this.$router.push({ path: url, query: { id: str, gourl: gourl } })
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},


		exportExcelTemplate0() {
			this.getAction({
				url: enterpriseEngraveApply.querySeal0,
			}).then(res => {
				const link = document.createElement("a"); // 创建a标签
				link.href = file_service.download + res;
				link.target = '_blank';
				link.click();
			})
		},
		exportExcelTemplate1() {

			this.getAxios('get',enterpriseEngraveApply.querySeal1,{
				params:{}
			}, (res) => {
				const link = document.createElement("a"); // 创建a标签
				link.href = file_service.download + res.data.data;
				link.target = '_blank';
				link.click();
			})
		},
		exportExcelTemplate2() {
			this.getAction({
				url: enterpriseEngraveApply.querySeal2,
			}).then(res => {
				const link = document.createElement("a"); // 创建a标签
				link.href = file_service.download + res;
				link.target = '_blank';
				link.click();
			})
		},
		isSubmit() {
			this.form.schedule = '0'
			this.form.isSubmit = 1
			this.form.firstTrial = 0
			this.onSubmit();
		},
		back() {
			this.$router.push({ path: '/sys/EnterpriseSealService' })
		},
		/*提交表单操作*/
		onSubmit() {
				if (!this.submitUrl) {
					this.$notification.warning({
						message: '提示',
						description: '请设置表单操作url地址',
					});
				} else {
					this.$refs.ruleForm
						.validate()
						.then(() => {
							this.confirmLoading = true;
							this.form.reason = ' ';
							let params = this.transformParams
								? this.transformParams(this.form)
								: this.form;
							/*后台请求*/
							this.getAxios('post',this.submitUrl,{
								params
								}, (res) => {
								this.confirmLoading = false;
								this.$notification.success({
									message: '提示',
									description: res.msg || '操作成功',
								});

								setTimeout(() => {
									this.goMore('/EnterpriseSealService', this.form.companyCode ? this.form.companyCode : this.$route.query.id, 'list')
								}, 500);
								if (this.onSuccessFn) {
									this.onSuccessFn(res);

								}
								if (this.isModal) {
									this.$emit('finish');
									this.onClose();
								}
							}).catch(() => {
								this.confirmLoading = false;
							})
						})
						.catch(error => {
							if (error.errorFields.length) {
								this.$notification.error({
									message: '请检查必填项，必填项目不能不填',
								});
							}
							window.console.log('error', error);
						});
				}
		},
		getFormData() {
			this.getAxios('get',enterpriseEngraveApply.detail,{
				params:{id: this.$route.query.id?this.$route.query.id:ls.get('jwtphone')}
			}, (res) => {
				this.form = res.data.data
			})
		},
	},
	beforeCreate() {
		// 修改背景色
		document.querySelector('body').setAttribute('style', 'background-color:#fff')
	}
	,
	beforeUnmount() {
		// 销毁背景色
		document.querySelector('body').removeAttribute('style')
	},
}
</script>
<style scoped lang="less">
.filePost {
	margin-bottom: 10px;

	h3 {
		line-height: 25px;
		padding-left: 15px;
		border-left: 4px solid #0059B5;
	}
}

/*
:deep(.ant-upload.ant-upload-select-picture-card){
	width:215px!important;
	height: 132.22px;
}
:deep(.ant-upload-list-picture-card .ant-upload-list-item){
	width:215px!important;
	height: 132.22px;
	padding:0!important;
}
*/
:deep(.ant-col){
    padding-bottom: 10px;
}
:deep(.img-upload) {
	width: 200px;
	height: 120px;
}

:deep(.ant-upload-list) {
	position: absolute;
	top: 0;
}

:deep(.ant-upload-list-picture-card-container) {
	width: 200px;
	height: 120px;
}

:deep(.ant-upload-list-item) {
	width: 200px;
	height: 120px;
}

:deep(.ant-table-scroll table) {
	min-height: 170px;
}

.codeBtnWordMark {
	width: 100%;
	height: 40px;
	background: rgba(136, 135, 135, 0.6);
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
}

.headerBox {
	width: 100%;
	height: 92px;
	background-color: #fff;

	.hearderContentBox {
		width: 1200px;
		margin: 0 auto;

		.titleBox {
			cursor: pointer;
			overflow: hidden;
			float: left;
			line-height: 92px;
			font-size: 30px;
			font-weight: bold;

			.logoBox {
				float: left;
				width: 73px;
				height: 66px;
				margin-right: 5px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.rightBox {
			float: right;
			display: flex;
			justify-content: space-around;
			line-height: 92px;
			font-size: 16px;

			a {
				font-weight: 600;
			}

			.loginBox {
				// float: left;
				cursor: pointer;
			}

			.loginBox:hover {
				color: #fc550b;
			}

			.lineBox {
				height: 18px;
				top: 36px;
			}

			.resigierBox {
				cursor: pointer;
				// float: left;
			}

			.resigierBox:hover {
				color: #fc550b;
			}
		}
	}
}

.bannerBox {
	position: relative;
	width: 100%;

	:deep(.ant-carousel) {
		position: relative;
		width: 100%;
	}

	.bannerImg {
		width: 100%;
		height: 282px;

		img {
			width: 100%;
			object-fit: cover;
			height: 280px;
		}
	}
}



.floatBox {
	width: 100%;

	.textBox {
		width: 100%;
		height: 250px;
		background-image: url('../../../assets/img/resigter.jpg');
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;

		.text {
			font-size: 30px;
			color: #fff;
			font-weight: 700;
		}
	}

	.midBox {
		position: relative;
		width: 100%;
		min-height: 50vh;

		.midFloatBox {
			overflow: hidden;
			width: 1200px;
			height: 100%;
			padding: 18px 15px 25px;
			margin: -40px auto 40px auto;
			background-color: #fff;
			box-shadow: 0 10px 15px rgba(39, 69, 167, .2);
			border-radius: 5px;

			.breadBox {
				// width: 1200px;
				margin: 3px 0 15px;
				font-size: 16px;
			}

			.tabBox {
				overflow: hidden;
				width: 100%;
				min-height: calc(100vh - 400px);
				margin: 0 auto;

				.code {
					text-align: center;
					height: 30px;
					background: #e2e2e2;
					line-height: 30px;
					font-size: 24px;
				}

				.layout-header {
					background-color: #ffffff;
					height: auto;
					padding-top: 30px;
				}

				//
				//.layout-content {
				//  background: url(../../assets/img/login-bg.png) center center no-repeat #ffffff;
				//  padding: 60px 0;
				//}

				.layout-footer {
					background-color: #ffffff;
				}

				.container {
					//width: 90%;
					//height: 80%;
					margin-left: auto;
					margin-right: auto;
					padding-top: 30px;
					//padding-top: 48%;
					//background: url(../../assets/img/login-image.png) center center no-repeat;
					//background-size: 80%;

				}

				.login-form {
					width: 70%;
					margin: 40px auto;

					h3 {
						margin: 0 0 30px;
						position: relative;
						padding-left: 15px;

						span {
							position: absolute;
							left: 0;
							display: block;
							height: 60%;
							top: 20%;
							width: 4px;
							background: #1890ff;
						}
					}

					.btnBB {
						width: 300px;
						margin: 0 auto;
					}

					:deep(.ant-form-item-label > label) {
						font-size: 16px;
					}
				}

				.ant-col-10 {
					margin-top: -43%;
					margin-left: 12%;
				}

				.title {
					font-size: 60px;
					font-weight: 500;
					margin: 40px 0;
				}



				.vcode-img {
					display: block;
					width: 100%;
					height: 50px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.login-img {
					display: block;
					width: 100%;
				}

			}
		}

	}
}

.footerBox {
	width: 100%;
	background-color: #333333;

	.footerContent {
		position: relative;
		margin: 0 auto;
		padding: 24px 0;
		width: 1200px;

		.firstLine {
			padding: 8px 0;
			font-size: 14px;
			color: #999;

			span {
				margin-right: 18px;
			}
		}

		.footCode {
			position: absolute;
			right: 0;
			bottom: 12%;
			text-align: center;

			.footEwm {
				margin-bottom: 8px;
			}

			.footEwmTitle {
				color: #999;
			}
		}
	}
}

:deep(.ant-list-lg .ant-list-item) {
	padding: 16px 8px;
}</style>
